import { Module } from 'vuex';
import { ExecutionTimingListState } from './types';
import { RootState } from '../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: ExecutionTimingListState = {
    list: undefined,
    index: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const executionTimingLists: Module<ExecutionTimingListState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
